import {useEffect} from 'react';

let onClickOutsideStatus=true;

export const updateOnClickOutsideStatus=(status)=>{
    onClickOutsideStatus=status;
};

const useOnClickOutside=(ref, handler, condition = true)=>{
    useEffect(
        () => {
            // Only add the listener if the condition is true
            if(!condition) {
                return;
            }

            const listener = (event) => {
                // Check if the clicked element is inside the modal or any of its children
                if(!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                if(onClickOutsideStatus)
                    handler(event);
            };
            document.addEventListener('click', listener);
            return () => {
                document.removeEventListener('click', listener);
            };
        },
        [ref, handler]
    );

};
export default useOnClickOutside;
